import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client
import fetch from "node-fetch";
//import reactStringReplace from 'react-string-replace';

import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

const QUERY_getnhmaphome = gql`
  query getnhmaphome(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getnhmaphome(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      ListingKeyNumeric
      BedroomsTotal
      BathroomsTotalInteger
      BathroomsFull
      BathroomsHalf
      City
      Country
      CountyOrParish
      Latitude
      Longitude
      ListAgentFullName
      ListAgentStateLicense
      ListAgentMLS
      ListPrice
      LivingArea
      ListOfficeName
      LotSizeArea
      LotSizeUnits
      ListingId
      Media
      MlsStatus
      ModificationTimestamp
      PostalCode
      PropertyType
      PropertySubType
      PostalCity
      PublicRemarks
      StandardStatus
      StateOrProvince
      SourceId
      ThumbnailUrl
      UnparsedAddress
      YearBuilt
      ClosePrice
      AssociationFee
      DaysOnHouseBerry
      ListAgentPreferredPhone
      History {
        id
        date
        event
        price
      }
    }
  }
`;

const QUERY_getschoolinhome = gql`
  query getschoolinhome(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getschoolinhome(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      CDSCode
      County
      District
      School
      StreetAbr
      City
      State
      PhoneNumber
      Website
      GSserved
      Boundary
      SchoolLat
      SchoolLong
      NumberofStudents
      StudentRatio
      GreatSchoolsRating
      AcademicProgressCollegeReadiness
      TestScores
      EquityReview
      latlangs
      greatschoolurl
    }
  }
`;

const QUERY_getMlslistings = gql`
  query getMlslistings(
    $coordinates: String
    $propertyType: [String]
    $forSale: [String]
    $forRent: [String]
    $bathsFilter: bathsFilter
    $bedFilter: bedFilter
    $priceFilter: priceFilter
    $soldDays: Int
    $page: String
  ) {
    getMlslistings(
      coordinates: $coordinates
      propertyType: $propertyType
      forSale: $forSale
      forRent: $forRent
      baths: $bathsFilter
      bed: $bedFilter
      price: $priceFilter
      soldDays: $soldDays
      page: $page
    ) {
      ListingKeyNumeric
      BedroomsTotal
      BathroomsTotalInteger
      BathroomsFull
      BathroomsHalf
      City
      Country
      CountyOrParish
      Latitude
      Longitude
      ListAgentFullName
      ListAgentStateLicense
      ListAgentMLS
      ListPrice
      LivingArea
      ListOfficeName
      LotSizeArea
      LotSizeUnits
      ListingId
      Media {
        MediaURL
      }
      MlsStatus
      ModificationTimestamp
      PostalCode
      PropertyType
      PropertySubType
      PostalCity
      PublicRemarks
      StandardStatus
      StateOrProvince
      ThumbnailUrl
      UnparsedAddress
      YearBuilt
      ClosePrice
    }
  }
`;

const QUERY_getSlipstreamListings = gql`
  query getSlipstreamListings(
    $coordinates: String
    $propertyType: [String]
    $forSale: [String]
    $forRent: [String]
    $bathsFilter: bathsFilter
    $bedFilter: bedFilter
    $priceFilter: priceFilter
    $soldDays: Int
    $page: String
  ) {
    getSlipstreamListings(
      coordinates: $coordinates
      propertyType: $propertyType
      forSale: $forSale
      forRent: $forRent
      baths: $bathsFilter
      bed: $bedFilter
      price: $priceFilter
      soldDays: $soldDays
      page: $page
    ) {
      ListingKeyNumeric
      BedroomsTotal
      BathroomsTotalInteger
      BathroomsFull
      BathroomsHalf
      City
      Country
      CountyOrParish
      Latitude
      Longitude
      ListAgentFullName
      ListAgentStateLicense
      ListAgentMLS
      ListPrice
      LivingArea
      ListOfficeName
      LotSizeArea
      LotSizeUnits
      ListingId
      Media {
        MediaURL
      }
      MlsStatus
      ModificationTimestamp
      PostalCode
      PropertyType
      PropertySubType
      PostalCity
      PublicRemarks
      StandardStatus
      StateOrProvince
      ThumbnailUrl
      UnparsedAddress
      YearBuilt
      ClosePrice
    }
  }
`;

const QUERY_getListingsByIds = gql`
  query getListingsByIds($ListingKeyNumerics: [Int]) {
    getListingsByIds(ListingKeyNumerics: $ListingKeyNumerics) {
      ListingKeyNumeric
      BedroomsTotal
      BathroomsTotalInteger
      BathroomsFull
      BathroomsHalf
      City
      Country
      CountyOrParish
      Latitude
      Longitude
      ListAgentFullName
      ListAgentStateLicense
      ListAgentMLS
      ListPrice
      LivingArea
      ListOfficeName
      LotSizeArea
      LotSizeUnits
      ListingId
      Media {
        MediaURL
      }
      MlsStatus
      ModificationTimestamp
      PostalCode
      PropertyType
      PropertySubType
      PostalCity
      PublicRemarks
      StandardStatus
      StateOrProvince
      ThumbnailUrl
      UnparsedAddress
      YearBuilt
      ClosePrice
      AssociationFee
      DaysOnHouseBerry
      History {
        id
        date
        event
        price
      }
      ListAgentEmail
      ListAgentPreferredPhone
      OriginalOnMarketDate
      OpenHouseYN
      OpenHouseSchedule
    }
  }
`;

const QUERY_getSlipStreamListngsByIds = gql`
  query getSlipStreamListngsByIds($ListingKeyNumerics: [Int]) {
    getSlipStreamListngsByIds(ListingKeyNumerics: $ListingKeyNumerics) {
      ListingKeyNumeric
      BedroomsTotal
      BathroomsTotalInteger
      BathroomsFull
      BathroomsHalf
      City
      Country
      CountyOrParish
      Latitude
      Longitude
      ListAgentFullName
      ListAgentStateLicense
      ListAgentMLS
      ListPrice
      LivingArea
      ListOfficeName
      LotSizeArea
      LotSizeUnits
      ListingId
      Media {
        MediaURL
      }
      MlsStatus
      ModificationTimestamp
      PostalCode
      PropertyType
      PropertySubType
      PostalCity
      PublicRemarks
      StandardStatus
      StateOrProvince
      ThumbnailUrl
      UnparsedAddress
      YearBuilt
      ClosePrice
      AssociationFee
      DaysOnHouseBerry
      History {
        id
        date
        event
        price
      }
      ListAgentEmail
      ListAgentPreferredPhone
      OriginalOnMarketDate
      OpenHouseYN
      OpenHouseSchedule
    }
  }
`;

const QUERY_getMLSListingByAddress = gql`
  query getMLSListingByAddress($address: String) {
    getMLSListingByAddress(address: $address) {
      ListingKeyNumeric
      BedroomsTotal
      BathroomsTotalInteger
      BathroomsFull
      BathroomsHalf
      ClosePrice
      City
      Country
      CountyOrParish
      Latitude
      Longitude
      ListAgentFullName
      ListAgentStateLicense
      ListAgentMLS
      ListPrice
      LivingArea
      ListOfficeName
      LotSizeArea
      LotSizeUnits
      ListingId
      Media {
        MediaURL
      }
      MlsStatus
      ModificationTimestamp
      PostalCode
      PropertyType
      PropertySubType
      PostalCity
      PublicRemarks
      StandardStatus
      StateOrProvince
      ThumbnailUrl
      UnparsedAddress
      YearBuilt
    }
  }
`;

const QUERY_MlslistingsAddressSuggestions = gql`
  query MlslistingsAddressSuggestions($address: String) {
    MlslistingsAddressSuggestions(address: $address) {
      ListingKeyNumeric
      UnparsedAddress
      City
      StateOrProvince
      PostalCode
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Get list by own query
async function getNHmaphomelist(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getnhmaphome,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getMlslistings(getdata) {
  let varibledata = {
    coordinates: getdata.appdata.coordinate,
  };
  if (getdata.appdata.page) {
    varibledata.page = getdata.appdata.page;
  }
  if (getdata.appdata.propertyType) {
    varibledata.propertyType = getdata.appdata.propertyType;
  }
  if (getdata.appdata.forRent) {
    varibledata.forRent = getdata.appdata.forRent;
  }
  if (getdata.appdata.forSale) {
    varibledata.forSale = getdata.appdata.forSale;
  }
  if (getdata.appdata.price) {
    varibledata.priceFilter = getdata.appdata.price;
  }
  if (getdata.appdata.bed) {
    varibledata.bedFilter = getdata.appdata.bed;
  }
  if (getdata.appdata.bath) {
    varibledata.bathsFilter = getdata.appdata.bath;
  }
  if (getdata.appdata.soldDays > 0) {
    varibledata.soldDays = getdata.appdata.soldDays;
  }
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getMlslistings,
        options: {
          fetch: fetch,
        },
        variables: varibledata,
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getSlipstreamListings(getdata) {
  let varibledata = {
    coordinates: getdata.appdata.coordinate,
  };
  if (getdata.appdata.page) {
    varibledata.page = getdata.appdata.page;
  }
  if (getdata.appdata.propertyType) {
    varibledata.propertyType = getdata.appdata.propertyType;
  }
  if (getdata.appdata.forRent) {
    varibledata.forRent = getdata.appdata.forRent;
  }
  if (getdata.appdata.forSale) {
    varibledata.forSale = getdata.appdata.forSale;
  }
  if (getdata.appdata.price) {
    varibledata.priceFilter = getdata.appdata.price;
  }
  if (getdata.appdata.bed) {
    varibledata.bedFilter = getdata.appdata.bed;
  }
  if (getdata.appdata.bath) {
    varibledata.bathsFilter = getdata.appdata.bath;
  }
  if (getdata.appdata.soldDays > 0) {
    varibledata.soldDays = getdata.appdata.soldDays;
  }
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getSlipstreamListings,
        options: {
          fetch: fetch,
        },
        variables: varibledata,
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
async function getMLSListingByAddress(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getMLSListingByAddress,
        options: {
          fetch: fetch,
        },
        variables: {
          address: getdata.address,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getListingsByIds(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getListingsByIds,
        options: {
          fetch: fetch,
        },
        variables: {
          ListingKeyNumerics: getdata.ListingKeyNumerics,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getSlipStreamListngsByIds(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getSlipStreamListngsByIds,
        options: {
          fetch: fetch,
        },
        variables: {
          ListingKeyNumerics: getdata.ListingKeyNumerics,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
async function getSchoolinHome(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getschoolinhome,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function MlslistingsAddressSuggestions(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_MlslistingsAddressSuggestions,
        options: {
          fetch: fetch,
        },
        variables: {
          address: getdata.address,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export {
  getNHmaphomelist,
  getSchoolinHome,
  getMlslistings,
  getListingsByIds,
  getMLSListingByAddress,
  MlslistingsAddressSuggestions,
  getSlipstreamListings,
  getSlipStreamListngsByIds,
};
